/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Data API Specification
 * OpenAPI spec version: 0.0.7
 */

export type MetaStatV7RequestPeriod =
  (typeof MetaStatV7RequestPeriod)[keyof typeof MetaStatV7RequestPeriod];

export const MetaStatV7RequestPeriod = {
  p10m: 'p10m',
  p12h: 'p12h',
  p12s: 'p12s',
  p14d: 'p14d',
  p1d: 'p1d',
  p1h: 'p1h',
  p1m: 'p1m',
  p30d: 'p30d',
  p30m: 'p30m',
  p31d: 'p31d',
  p3d: 'p3d',
  p3h: 'p3h',
  p3m: 'p3m',
  p5m: 'p5m',
  p5s: 'p5s',
  p6d: 'p6d',
  p6h: 'p6h',
  p6m: 'p6m',
  p7d: 'p7d',
} as const;
